const LABEL_ADMIN_SYSTEMS_TABLE = {
  columns: [
    {
      label: 'admin_info.system_name_header',
      field: 'name',
      translate: false,
      ordering: true
    },
    {
      label: 'admin_info.role_header',
      field: 'role',
      translate: true,
      getValue: (raw) => {
        return 'admin_role.' + raw.role;
      },
      ordering: true
    },
    {
      label: 'admin_info.status_header',
      field: 'status',
      translate: true,
      getValue: (raw) => {
        return 'admin_system_status.' + raw.status;
      },
      ordering: true
    }
  ]
}

export default LABEL_ADMIN_SYSTEMS_TABLE;
